<template>
    <transition name="slide-fade">
        <div class="modal" data-cy="modal_draw_delivery" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-sm text-a-blue-001b73">
                    <img class="fixed left-0 right-0 w-40 h-48 mx-auto -mt-20" data-cy="img_modal_draw_delivery_check" :src="initImageUrls()">
                    <div class="pt-28 pb-2 px-4">
                        <div class="text-center text-20 font-medium mb-2 pt-3" data-cy="text_modal_draw_delivery_title" v-html="title"></div>
                        <div class="text-center text-16 font-regular">
                            <span v-if="isPrivilegeMessage"
                                data-cy="text_modal_draw_delivery_msg"
                                v-html="privilegeMessage"></span>
                            <span v-if="isDelivery"
                                data-cy="text_modal_draw_delivery_draw_msg"
                                v-html="deliveryMessage"></span>
                            </div>
                    </div>
                    <div class="grid grid-cols-2 gap-2 w-full p-4">
                        <div>
                            <button class="w-full btn bg-a-white-ffffff border border-a-blue-2140a6 font-bold text-a-blue-2140a6 text-18 rounded-sm p-1" data-cy="btn_modal_draw_delivery_close" @click="clickClose()">
                                {{lbl.serial.delivery.btn_close}}
                            </button>
                        </div>
                        <div>
                            <button class="w-full btn bg-a-blue-2140a6 text-a-white-ffffff font-bold text-18 rounded-sm p-1 " @click="clickOk()">
                                {{btnOk}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import { CampaignType } from "@/helper/StaticValue.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ConfigManager from "@/config/ConfigManager.js";
export default {
    name: "DrawDeliveryModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,

            drawDeliveryModel: null,

            deliveryMessage: '',
            isDelivery: false,

            privilegeMessage: '',
            isPrivilegeMessage: false,
            title: '',
            btnOk: ''
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.drawDeliveryModel = config.drawDeliveryModel;
            this.title = config.title;
            this.btnOk = config.btnOk;
            this.initial();

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickClose: function () {
            this.hide();
            this.controller.sendCallbackClose();
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        initial: function () {
            if(this.drawDeliveryModel.privilegeMessage) {
                this.isPrivilegeMessage = true;
                this.privilegeMessage= this.drawDeliveryModel.privilegeMessage;
            } else {
                if(this.drawDeliveryModel.delivered == true) {
                    this.isDelivery = true;
                    this.deliveryMessage = this.lbl.serial.delivery.msg;
                }

                if(this.drawDeliveryModel.type == CampaignType.Draw) {
                    this.isPrivilegeMessage = true;
                    this.privilegeMessage = this.getDrawMessage();
                }
            }
        },

        getDrawMessage: function () {
            let date = DatetimeHelper.getDatetimeFullFormat( this.drawDeliveryModel.campaignExpiredTimestamp);
            return Util.stringFormat(this.lbl.serial.draw, date);
        },
        initImageUrls: function() {
            var appId = ConfigManager.getAppId();
            var baseUrl = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/`;
            
            // images loading
            return baseUrl + 'image/modalconfirm/img-fish-confirm.png';
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;

        .modal-content {
            width: 420px;

            @include mobile {
                width: 100%;
                padding: 20px;
            }
        }
        .btn {
            height: 50px;
        }
    }
</style>
